import type { ReactNode } from 'react';
import { Flex } from '@/uicomponents';
import styles from './page-container.module.css';

export type PageContainerWidth = 'sm' | 'md' | 'lg' | 'xl' | 'wide' | 'full';
export type PageContainerPadding = 'default' | 'compact';

interface PageContainerProps {
  maxWidth: PageContainerWidth;
  padding?: PageContainerPadding;
  /** Reserve the fixed `EditFooterBar`'s height so the last rows clear it. */
  hasFooterBar?: boolean;
  children: ReactNode;
}

export const PageContainer = ({
  maxWidth,
  padding = 'default',
  hasFooterBar = false,
  children,
}: PageContainerProps) => {
  const className = [
    styles.container,
    styles[maxWidth],
    padding === 'compact' ? styles.paddingCompact : styles.paddingDefault,
    hasFooterBar ? styles.paddingFooterBar : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Flex vertical className={className}>
      {children}
    </Flex>
  );
};
